import React from "react";
import { Link } from "react-router-dom";
import { Search, FileSpreadsheet, Mouse, Braces } from "lucide-react";
import "../styles/AccessibilityGrid.scss";

interface AccessibilityAreaProps {
  title: string;
  slug: string;
  backgroundPosition: string;
  icon: React.ReactNode;
}

const AccessibilityGrid: React.FC = () => {
  const imgSrc = "/lovable-uploads/64c2aceb-d52a-4cee-8186-b8f3ccc845d7.png";
  
  const accessibilityAreas: AccessibilityAreaProps[] = [
    {
      title: "Visual Accessibility",
      slug: "visual",
      backgroundPosition: "top left",
      icon: <Search className="accessibility-grid__icon" aria-hidden="true" />
    },
    {
      title: "Editorial Accessibility",
      slug: "editorial",
      backgroundPosition: "top right",
      icon: <FileSpreadsheet className="accessibility-grid__icon" aria-hidden="true" />
    },
    {
      title: "Accessible Usability",
      slug: "usability",
      backgroundPosition: "bottom left",
      icon: <Mouse className="accessibility-grid__icon" aria-hidden="true" />
    },
    {
      title: "Technical Accessibility",
      slug: "technical",
      backgroundPosition: "bottom right",
      icon: <Braces className="accessibility-grid__icon" aria-hidden="true" />
    }
  ];

  return (
    <div className="accessibility-grid" aria-labelledby="accessibility-grid-heading">
      <h2 id="accessibility-grid-heading" className="sr-only">Accessibility Categories</h2>
      <div className="accessibility-grid__container">
        {accessibilityAreas.map((area, index) => (
          <Link 
            to={`/accessibility/${area.slug}`} 
            key={area.slug}
            className="accessibility-grid__card"
            style={{
              backgroundImage: `url(${imgSrc})`,
              backgroundPosition: area.backgroundPosition,
              backgroundSize: '200% 200%'
            }}
            role="presentation"
          >
            <div className="accessibility-grid__overlay" aria-hidden="true"></div>
            <div className="accessibility-grid__content">
              <div className="accessibility-grid__icon-wrapper" aria-hidden="true">
                {area.icon}
              </div>
              <span className="accessibility-grid__title">{area.title}</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default AccessibilityGrid; 